import React from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Typography, Divider } from "antd";
import {
  AuditOutlined,
  BankOutlined,
  FileDoneOutlined,
  DollarCircleOutlined,
  TransactionOutlined,
} from "@ant-design/icons";

const { Text, Title } = Typography;

function MenuCourt({ onClick }) {
  const navigate = useNavigate();
  const ROLE_ID = localStorage.getItem("ROLE_ID");

  const handleMenuClick = (item) => {
    if (onClick) onClick(item.label); // ส่งชื่อไปที่ Header
    navigate(item.path);
  };

  const menuGroups = [
    {
      groupTitle: "ชั้นศาล",
      show: ROLE_ID === "1" || ROLE_ID === "3",
      items: [
        {
          icon: <BankOutlined />,
          label: "ชั้นศาล > พิพากษา",
          path: "/court/create-judgment",
          show: true,
        },
        {
          icon: <AuditOutlined />,
          label: "ชั้นศาล > ใบปะหน้า",
          path: "/court/enforce-case-doc",
          show: true,
        },
        {
          icon: <DollarCircleOutlined />,
          label: "ชั้นศาล > เบิกเงินทดรอง",
          path: "/court/withdraw-advance-payment-court",
          show: true,
        },
        {
          icon: <TransactionOutlined />,
          label: "ชั้นศาล > เคลียร์เงินทดรอง",
          path: "/court/clear-advance-payment-court",
          show: true,
        },
        {
          icon: <AuditOutlined />,
          label: "ชั้นศาล > เพิ่มเอกสารคำบังคับ",
          path: "/court/enforce-case",
          show: true,
        },

        {
          icon: <FileDoneOutlined />,
          label: "ชั้นศาล > คดีถึงที่สุด/อุธรณ์",
          path: "/court/final-judgment-or-appeal",
          show: true,
        },
      ],
    },
  ];

  return (
    <div className="dashboard-wrapper">
      {menuGroups.map(
        (group, gIndex) =>
          group.show && (
            <div key={gIndex}>
              <Divider orientation="left">
                <Title level={4}>{group.groupTitle}</Title>
              </Divider>
              <Row gutter={[24, 24]}>
                {group.items.map(
                  (item, index) =>
                    item.show && (
                      <Col xs={12} sm={8} md={6} lg={4} key={index}>
                        <div
                          className="menu-card"
                          onClick={() => handleMenuClick(item)}
                        >
                          <div className="icon-wrapper">{item.icon}</div>
                          <Text className="menu-text-gold">
                            {
                              item.label.includes(">")
                                ? item.label.split(">")[1] // ถ้ามี '>' ให้เอาตัวหลังสุดมาโชว์
                                : item.label // ถ้าไม่มีให้โชว์ปกติ
                            }
                          </Text>
                        </div>
                      </Col>
                    ),
                )}
              </Row>
            </div>
          ),
      )}
    </div>
  );
}

export default MenuCourt;
